/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {webDeviceInfo} from '../api'

export const useMutationWebDeviceInfo = createReactQueryMutationHook('webDeviceInfo', webDeviceInfo)
